<template>
    <div
        :class="`audit-state audit-state--${state.class} display--inline-b color--white position--relative capitalize pointer capitalize svg--parent`"
        @mouseover="show = true"
        @mouseleave="show = false">
        <tooltip
            v-if="$t(`states.${state.translate}`)"
            v-show="show"
            class="cblock__tooltip--audit-state capitalize"
            direction="top"
            animation="top--base"
            arrow="base"
            v-html="$t(`states.${state.translate}`)"
        />
    </div>
</template>

<script>
// packages
import { reactive, toRefs } from '@vue/composition-api';

export default {
    components: {
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' )
    },
    props: {
        value: Number,
        data: Object
    },
    setup ( props, { root: { $route } }) {
        const states = {
            default: {
                1: { translate: 'enabled', class: 'enabled' },
                2: { translate: 'desactivated', class: 'disabled' }
            },
            campaigns: {
                1: { translate: 'enabled', class: 'enabled' },
                2: { translate: 'standby', class: 'inactive' },
                3: { translate: 'closed', class: 'disabled' }
            },
            audit: {
                1: { translate: 'received', class: 'standby' },
                2: { translate: 'pending', class: 'inactive' },
                3: { translate: 'closed', class: 'disabled' },
                4: { translate: 'delivered', class: 'enabled' }
            }
        };

        // Caso seja uma página singular, é necessário
        // obter a route pai. Caso não seja, basta o nome
        // da rota.
        const model = $route.meta.parent || $route.name;
        // obtenção do tipo de estado.
        const type = ![ 'campaigns', 'audit' ].includes( model ) ? 'default' : model;

        // obter e mostrar estado da ultima chamada na página de audit
        const tooltip = reactive({
            show: false
        });

        let lastCallState = '';
        if ( type === 'audit' && props.data )
            lastCallState = props.data.latestContactCallState;

        // valida se o estado é diferente de disabled
        //    caso seja, é retornado o estado default.
        //    caso não seja, é validado a rota em que o
        //        utilizador está, de forma a perceber que tradução
        //        é a mais adequada.

        const state = states[type][props.value];

        return {
            state,
            lastCallState,
            ...toRefs( tooltip )
        };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $states-classes:
        'enabled' $color-green,
        'inactive' $color-yellow,
        'disabled' $color-red,
        'standby' $color-grey;

    // =============================================================================
    // Style
    // =============================================================================
    .audit-state {
        display: inline-block;
        @include dimensions( 24px );
        @include typography-specs( 16px, 23px );
        padding: 0 10px;
        margin-right: 10px;
        @include rounded-corner( 50% );
        @each $class, $color in $states-classes {
            &--#{$class} {
                background: $color;
            }
        }
    }
    .cblock {
        &__tooltip {
            &--audit-state {
               @include transform-position( -26px, false, false, 0 );
               width: max-content;
            }
        }
    }
</style>